import { render, staticRenderFns } from "./zhulao.vue?vue&type=template&id=6e128c62&scoped=true&"
import script from "./zhulao.vue?vue&type=script&lang=js&"
export * from "./zhulao.vue?vue&type=script&lang=js&"
import style0 from "./zhulao.vue?vue&type=style&index=0&id=6e128c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e128c62",
  null
  
)

export default component.exports